import { attr, ProtoBaseModel } from '@square/dashboard-data/utils/ember-model-stubs';
import { FirstPartyAddon as FirstPartyAddonProto } from '@square/dashboard-protos/models/squareup/addons/shared/first_party_addons';
import { alias } from '@ember/object/computed';
import Enum from '@square/dashboard-utilities/utils/enum';
export const FirstPartyAddon = new Enum(Object.keys(FirstPartyAddonProto));
export default ProtoBaseModel.extend({
  isEnabled: attr(Boolean, {
    defaultValue: true
  }),
  firstPartyAddon: attr(FirstPartyAddon),
  addonId: alias('firstPartyAddon')
});